export const ADD_TOAST = 'ADD_TOAST';
export const REMOVE_TOAST = 'REMOVE_TOAST';


export interface ToastProperties {
    icon: React.ReactNode;
    color: string;
}


export type Toast = {
    id?: number,
    type: 'default' | 'success' | 'warning' | 'error' | 'custom',
    title: string,
    description: string,
    color?: string,
    icon?: React.ReactNode,
    autoDeleteTime?: boolean,
    translationKey?: string;
};

export interface ToastState {
    list: Toast[],
    autoDeleteTime: number,
}